import {
    MarketResearchCompensationData,
    MarketResearchDiversityData,
    MarketResearchSearchCriteria,
    MarketResearchShareData,
    MarketResearchSummaryData,
    MarketResearchSupplyDemandData,
    RelodeApiError,
} from "@relode/core";
import {
    ActionsUnion,
    createAction,
} from "@relode/core/components/reducer/actionHelpers";
import { JobManagerContact } from "core/src/domain";

enum names {
    MARKET_RESEARCH_UPDATE_CRITERIA = "MARKET_RESEARCH_UPDATE_CRITERIA",

    MARKET_RESEARCH_LOAD = "MARKET_RESEARCH_LOAD",
    MARKET_RESEARCH_LOAD_SUCCESS = "MARKET_RESEARCH_LOAD_SUCCESS",
    MARKET_RESEARCH_LOAD_FAILURE = "MARKET_RESEARCH_LOAD_FAILURE",

    MARKET_RESEARCH_COMPENSATION = "MARKET_RESEARCH_COMPENSATION",
    MARKET_RESEARCH_COMPENSATION_SUCCESS = "MARKET_RESEARCH_COMPENSATION_SUCCESS",
    MARKET_RESEARCH_COMPENSATION_FAILURE = "MARKET_RESEARCH_COMPENSATION_FAILURE",

    MARKET_RESEARCH_SUPPLY_DEMAND = "MARKET_RESEARCH_SUPPLY_DEMAND",
    MARKET_RESEARCH_SUPPLY_DEMAND_SUCCESS = "MARKET_RESEARCH_SUPPLY_DEMAND_SUCCESS",
    MARKET_RESEARCH_SUPPLY_DEMAND_FAILURE = "MARKET_RESEARCH_SUPPLY_DEMAND_FAILURE",

    MARKET_RESEARCH_DIVERSITY = "MARKET_RESEARCH_DIVERSITY",
    MARKET_RESEARCH_DIVERSITY_SUCCESS = "MARKET_RESEARCH_DIVERSITY_SUCCESS",
    MARKET_RESEARCH_DIVERSITY_FAILURE = "MARKET_RESEARCH_DIVERSITY_FAILURE",

    MARKET_RESEARCH_SHARE = "MARKET_RESEARCH_SHARE",
    MARKET_RESEARCH_SHARE_SUCCESS = "MARKET_RESEARCH_SHARE_SUCCESS",
    MARKET_RESEARCH_SHARE_FAILURE = "MARKET_RESEARCH_SHARE_FAILURE",

    MARKET_RESEARCH_SUMMARY = "MARKET_RESEARCH_SUMMARY",
    MARKET_RESEARCH_SUMMARY_SUCCESS = "MARKET_RESEARCH_SUMMARY_SUCCESS",
    MARKET_RESEARCH_SUMMARY_FAILURE = "MARKET_RESEARCH_SUMMARY_FAILURE",

    MARKET_RESEARCH_JOB_MANAGER = "MARKET_RESEARCH_JOB_MANAGER",
    MARKET_RESEARCH_JOB_MANAGER_SUCCESS = "MARKET_RESEARCH_JOB_MANAGER_SUCCESS",
    MARKET_RESEARCH_JOB_MANAGER_FAILURE = "MARKET_RESEARCH_JOB_MANAGER_FAILURE",
}

export default names;

export const creators = {
    updateMarketResearchSearchCriteria: (data: MarketResearchSearchCriteria) =>
        createAction(names.MARKET_RESEARCH_UPDATE_CRITERIA, { data }),

    loadMarketResearch: (data: MarketResearchSearchCriteria) =>
        createAction(names.MARKET_RESEARCH_LOAD, { data }),
    loadMarketResearchSuccess: () =>
        createAction(names.MARKET_RESEARCH_LOAD_SUCCESS),
    loadMarketResearchFailure: () =>
        createAction(names.MARKET_RESEARCH_LOAD_FAILURE),

    loadMarketResearchCompensation: () =>
        createAction(names.MARKET_RESEARCH_COMPENSATION),

    loadMarketResearchCompensationSuccess: (
        data: MarketResearchCompensationData
    ) => createAction(names.MARKET_RESEARCH_COMPENSATION_SUCCESS, { data }),

    loadMarketResearchCompensationFailure: (error: RelodeApiError) =>
        createAction(names.MARKET_RESEARCH_COMPENSATION_FAILURE, { error }),

    loadMarketResearchSupplyDemand: () =>
        createAction(names.MARKET_RESEARCH_SUPPLY_DEMAND),
    loadMarketResearchSupplyDemandSuccess: (
        data: MarketResearchSupplyDemandData
    ) => createAction(names.MARKET_RESEARCH_SUPPLY_DEMAND_SUCCESS, { data }),
    loadMarketResearchSupplyDemandFailure: (error: RelodeApiError) =>
        createAction(names.MARKET_RESEARCH_SUPPLY_DEMAND_FAILURE, { error }),

    loadMarketResearchDiversity: () =>
        createAction(names.MARKET_RESEARCH_DIVERSITY),

    loadMarketResearchDiversitySuccess: (data: MarketResearchDiversityData) =>
        createAction(names.MARKET_RESEARCH_DIVERSITY_SUCCESS, { data }),

    loadMarketResearchDiversityFailure: (error: RelodeApiError) =>
        createAction(names.MARKET_RESEARCH_DIVERSITY_FAILURE, { error }),

    loadMarketResearchShare: () => createAction(names.MARKET_RESEARCH_SHARE),
    loadMarketResearchShareSuccess: (data: MarketResearchShareData) =>
        createAction(names.MARKET_RESEARCH_SHARE_SUCCESS, {
            data,
        }),
    loadMarketResearchShareFailure: (error: RelodeApiError) =>
        createAction(names.MARKET_RESEARCH_SHARE_FAILURE, { error }),

    loadMarketResearchSummary: () =>
        createAction(names.MARKET_RESEARCH_SUMMARY),
    loadMarketResearchSummarySuccess: (data: MarketResearchSummaryData) =>
        createAction(names.MARKET_RESEARCH_SUMMARY_SUCCESS, { data }),
    loadMarketResearchSummaryFailure: (error: RelodeApiError) =>
        createAction(names.MARKET_RESEARCH_SUMMARY_FAILURE, { error }),

    loadMarketResearchJobManager: () =>
        createAction(names.MARKET_RESEARCH_JOB_MANAGER),
    loadMarketResearchJobManagerSuccess: (data: JobManagerContact) =>
        createAction(names.MARKET_RESEARCH_JOB_MANAGER_SUCCESS, { data }),
    loadMarketResearchJobManagerFailure: (error: RelodeApiError) =>
        createAction(names.MARKET_RESEARCH_JOB_MANAGER_FAILURE, { error }),
};

export type ClientMarketResearchActionTypes = ActionsUnion<typeof creators>;
